import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppOpenBanner, LazyAppSidebar, LazyAppSidebarContent, LazyAppSidebarFooter, LazyAppSidebarGroup, LazyAppSidebarHeader, LazyAppSidebarNav, LazyAppSidebarNavItem, LazyBottomNavMobile, LazyBrandDisplay, LazyCPConfirmationModal, LazyCarousel, LazyDarkModeSwitcher, LazyDragDropZone, LazyFileAttachmentCard, LazyGlobalErrorPage, LazyGridLoadingIndicator, LazyNewFeatureBadge, LazyProfileCardMenuPanel, LazyScheduleSessionDayList, LazySectionEmptyState, LazySelectableList, LazySelectableListRender, LazySidebarPopoverContent, LazySummaryCardMobile, LazySummaryCard, LazySummaryCardWeb, LazySwitcherSidebarMobile, LazySwitcherSidebar, LazyTopBarChatButton, LazyTopBarMobile, LazyAvatarBadgedAvatar, LazyAvatarShieldIcon, LazyCustomHamburgerMenuIcon, LazyExploreIcon, LazyStudioIcon, LazyEditorContent, LazyEditorRoot, LazyEditorUploadCarousel, LazyEditorComposablesUseEditor, LazyEditorComposablesUseKeyboardNavigation, LazyEditorExtensionsHashMentions, LazyEditorExtensions, LazyEditorExtensionsMentionPluginKeys, LazyEditorExtensionsUserMentions, LazyEditor, LazyEditorMentionsEditableMentionNode, LazyEditorMentions, LazyEditorMentionsUnifiedMention, LazyEditorSuggestionsHashMentionsList, LazyEditorSuggestionsMentionEmptyState, LazyEditorSuggestionsMentionsList, LazyEditorSuggestionsMentionsListItem, LazyEditorSuggestionsUserMentionsList, LazyEditorSuggestions, LazyEditorSuggestionsService, LazyEditorSuggestionsTypes, LazyEditorToolsCommentSwitcher, LazyEditorToolsEmojiPicker, LazyEditorToolsEventsPicker, LazyEditorToolsFileUpload, LazyEditorToolsFormatToolbar, LazyEditorToolsGifPicker, LazyEditorToolsHashPicker, LazyEditorToolsLinkEmbed, LazyEditorToolsVideoUploadModal, LazyEditorTools, LazyEditorTypes, LazyEditorTypesMentionTypes, LazyEditorTypesValidationTypes, LazyEditorUtilsMentionHelper, LazySpriteSymbol, LazySpriteSymbolInline } from '#components'
const lazyGlobalComponents = [
  ["AppOpenBanner", LazyAppOpenBanner],
["AppSidebar", LazyAppSidebar],
["AppSidebarContent", LazyAppSidebarContent],
["AppSidebarFooter", LazyAppSidebarFooter],
["AppSidebarGroup", LazyAppSidebarGroup],
["AppSidebarHeader", LazyAppSidebarHeader],
["AppSidebarNav", LazyAppSidebarNav],
["AppSidebarNavItem", LazyAppSidebarNavItem],
["BottomNavMobile", LazyBottomNavMobile],
["BrandDisplay", LazyBrandDisplay],
["CPConfirmationModal", LazyCPConfirmationModal],
["Carousel", LazyCarousel],
["DarkModeSwitcher", LazyDarkModeSwitcher],
["DragDropZone", LazyDragDropZone],
["FileAttachmentCard", LazyFileAttachmentCard],
["GlobalErrorPage", LazyGlobalErrorPage],
["GridLoadingIndicator", LazyGridLoadingIndicator],
["NewFeatureBadge", LazyNewFeatureBadge],
["ProfileCardMenuPanel", LazyProfileCardMenuPanel],
["ScheduleSessionDayList", LazyScheduleSessionDayList],
["SectionEmptyState", LazySectionEmptyState],
["SelectableList", LazySelectableList],
["SelectableListRender", LazySelectableListRender],
["SidebarPopoverContent", LazySidebarPopoverContent],
["SummaryCardMobile", LazySummaryCardMobile],
["SummaryCard", LazySummaryCard],
["SummaryCardWeb", LazySummaryCardWeb],
["SwitcherSidebarMobile", LazySwitcherSidebarMobile],
["SwitcherSidebar", LazySwitcherSidebar],
["TopBarChatButton", LazyTopBarChatButton],
["TopBarMobile", LazyTopBarMobile],
["AvatarBadgedAvatar", LazyAvatarBadgedAvatar],
["AvatarShieldIcon", LazyAvatarShieldIcon],
["CustomHamburgerMenuIcon", LazyCustomHamburgerMenuIcon],
["ExploreIcon", LazyExploreIcon],
["StudioIcon", LazyStudioIcon],
["EditorContent", LazyEditorContent],
["EditorRoot", LazyEditorRoot],
["EditorUploadCarousel", LazyEditorUploadCarousel],
["EditorComposablesUseEditor", LazyEditorComposablesUseEditor],
["EditorComposablesUseKeyboardNavigation", LazyEditorComposablesUseKeyboardNavigation],
["EditorExtensionsHashMentions", LazyEditorExtensionsHashMentions],
["EditorExtensions", LazyEditorExtensions],
["EditorExtensionsMentionPluginKeys", LazyEditorExtensionsMentionPluginKeys],
["EditorExtensionsUserMentions", LazyEditorExtensionsUserMentions],
["Editor", LazyEditor],
["EditorMentionsEditableMentionNode", LazyEditorMentionsEditableMentionNode],
["EditorMentions", LazyEditorMentions],
["EditorMentionsUnifiedMention", LazyEditorMentionsUnifiedMention],
["EditorSuggestionsHashMentionsList", LazyEditorSuggestionsHashMentionsList],
["EditorSuggestionsMentionEmptyState", LazyEditorSuggestionsMentionEmptyState],
["EditorSuggestionsMentionsList", LazyEditorSuggestionsMentionsList],
["EditorSuggestionsMentionsListItem", LazyEditorSuggestionsMentionsListItem],
["EditorSuggestionsUserMentionsList", LazyEditorSuggestionsUserMentionsList],
["EditorSuggestions", LazyEditorSuggestions],
["EditorSuggestionsService", LazyEditorSuggestionsService],
["EditorSuggestionsTypes", LazyEditorSuggestionsTypes],
["EditorToolsCommentSwitcher", LazyEditorToolsCommentSwitcher],
["EditorToolsEmojiPicker", LazyEditorToolsEmojiPicker],
["EditorToolsEventsPicker", LazyEditorToolsEventsPicker],
["EditorToolsFileUpload", LazyEditorToolsFileUpload],
["EditorToolsFormatToolbar", LazyEditorToolsFormatToolbar],
["EditorToolsGifPicker", LazyEditorToolsGifPicker],
["EditorToolsHashPicker", LazyEditorToolsHashPicker],
["EditorToolsLinkEmbed", LazyEditorToolsLinkEmbed],
["EditorToolsVideoUploadModal", LazyEditorToolsVideoUploadModal],
["EditorTools", LazyEditorTools],
["EditorTypes", LazyEditorTypes],
["EditorTypesMentionTypes", LazyEditorTypesMentionTypes],
["EditorTypesValidationTypes", LazyEditorTypesValidationTypes],
["EditorUtilsMentionHelper", LazyEditorUtilsMentionHelper],
["SpriteSymbol", LazySpriteSymbol],
["SpriteSymbolInline", LazySpriteSymbolInline],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
